import { firestore } from './firestore';
import store from '../store';
import moment from 'moment';

export const triggerInstructorStatus = (broadcastId, status) => {
  const teacherStatus = { status: status || 'offline', id: broadcastId, updated: moment().utc().format()};
  if(teacherStatus.status === 'offline') {
    teacherStatus.displayTime = 0;
    teacherStatus.interaction_id = null;
  }
  firestore.collection('broadcast-session').doc(broadcastId).set(teacherStatus, { merge: true});
}
export const triggerDisplaytime = (broadcastId, displayTime) => {
  const displayTimeUpdate = { displayTime, id: broadcastId, updated: moment().utc().format()};
  store.commit('player/setBroadcastDisplayTime', displayTime);
  firestore.collection('broadcast-session').doc(broadcastId).set(displayTimeUpdate, { merge: true});
}
export const triggerActiveInteraction = (broadcastId, activeInteraction) => {
  const activeInteractionUpdate = { interaction_id: activeInteraction, id: broadcastId, updated: moment().utc().format()};
  store.commit('player/setBroadcastActiveInteractionId', activeInteraction);
  firestore.collection('broadcast-session').doc(broadcastId).set(activeInteractionUpdate, { merge: true});
}
export const triggerInteractionItems = (broadcastId, displayTime, activeInteraction) => {
  const interactionItem = { displayTime, interaction_id: activeInteraction, id: broadcastId, updated: moment().utc().format()};
  // store.commit('player/setBroadcastDisplayTime', displayTime);
  store.commit('player/setBroadcastActiveInteractionId', activeInteraction);
  firestore.collection('broadcast-session').doc(broadcastId).set(interactionItem, { merge: true});
}
export const triggerPlayerState = (broadcastId, displayTime, state) => {
  const playerState = { displayTime, player_state: state, id: broadcastId, updated: moment().utc().format()};
  // store.commit('player/setBroadcastDisplayTime', displayTime);
  firestore.collection('broadcast-session').doc(broadcastId).set(playerState, { merge: true});
}

// --- STUDENT SIDE EVENTS
export const triggerLearnerStatus = (broadcastId, learnerId, bulbAttemptId, status) => {
  const learnerStatus = { status: status || 'offline', bulbAttemptId, updated: moment().utc().format()};

  firestore
    .collection('broadcast-session')
    .doc(broadcastId)
    .collection('history')
    .doc(learnerId+'')
    .set(learnerStatus, { merge: true});
}
export const triggerLearnerAttemptStatus = (broadcastId, learnerId, interaction_id) => {
  const learnerStatus = {};
  learnerStatus[interaction_id+''] = moment().utc().format();
  learnerStatus['updated'] = moment().utc().format();

  firestore
    .collection('broadcast-session')
    .doc(broadcastId)
    .collection('history')
    .doc(learnerId+'')
    .set(learnerStatus, { merge: true});
}
export const getCurrentInteractionFromFirestore = (broadcastId) => {
  return new Promise(function(resolve, reject) {
    firestore
    .collection('broadcast-session')
    .doc(broadcastId).get().then(snapshot => {
      if(snapshot.exists) {
        const data = snapshot.data();
        return resolve({
          interaction_id: data.interaction_id || null,
          displayTime: data.displayTime || 0,
          status: data.status || 'offline',
        });
      }
      else reject(null);
    });
  });
}

let historyEvent = null, broadcastEvent = null;
export const listenBroadcastEvents = (broadcastId, userType, cb) => {
  if(historyEvent !== null) historyEvent();
  if(broadcastEvent !== null) broadcastEvent();
  if(userType === 'teacher') {
    // -- listening to history changes
    historyEvent = firestore
    .collection('broadcast-session')
    .doc(broadcastId)
    .collection('history')
    .onSnapshot((snapshot) => {
      snapshot.docChanges().forEach(function(change) {
        cb('history', change.type, {
          learnerId: change.doc.id,
          data: change.doc.data()
        });
      });
    });
  }
  else if(userType === 'student') {
    broadcastEvent = firestore
    .collection('broadcast-session')
    .where("id", "==", broadcastId)
    .onSnapshot((snapshot) => {
      snapshot.docChanges().forEach(function(change) {
        cb('broadcast', change.type, {
          ...change.doc.data()
        });
      });
    });
  }
}
